<div class="mt-4">
  <nx-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <nx-tree-node *nxTreeNodeDef="let node" nxTreeNodePadding class="py-2">
      <a nxAction nxTreeNodeActionItem [href]="(node.isSpaLink ? '/' + globtroterApp : '') + node.link">
        <div class="flex gap-1 items-center">
          <nx-icon nxActionIcon size="s" name="launch" />
          <p class="text-xl font-semibold">
            {{ node.label }}
          </p>
        </div>
      </a>
    </nx-tree-node>
    <nx-tree-node *nxTreeNodeDef="let node; when: hasChild" nxTreeNodePadding class="py-3 cursor-pointer">
      <a nxAction nxTreeNodeActionItem nxTreeNodeToggle type="button" class="w-full">
        <div class="flex justify-between items-center">
          <div class="flex gap-1 items-center">
            <nx-icon nxActionIcon size="s" name="list" />
            <p class="text-xl font-semibold">
              {{ node.label }}
            </p>
          </div>
          <nx-icon nxActionIcon size="s" [name]="treeControl.isExpanded(node) ? 'chevron-up' : 'chevron-down'" />
        </div>
      </a>
    </nx-tree-node>
  </nx-tree>
</div>
